var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 33.99,
  height: 44.23,
  viewBox: "0 0 33.99 44.23",
  preserveAspectRatio: "xMidYMid meet"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "lock")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32.48,20.87H28.69V11.69a11.69,11.69,0,0,0-23.38,0v9.18H1.52A1.52,1.52,0,0,0,0,22.39V42.7a1.53,1.53,0,0,0,1.52,1.53h31A1.52,1.52,0,0,0,34,42.7V22.39A1.51,1.51,0,0,0,32.48,20.87Zm-8.73,0H10.24V11.69a6.76,6.76,0,1,1,13.51,0Z",
  fill: "currentColor"
})))));
export default SvgLock;